import {Link} from "react-router-dom";
import useApiUrl from '../framework/hooks/useApiUrlHook';
import useExtraFields from '../framework/hooks/useExtraHook';

export default function Header({ page }) {
    const apiUrl = useApiUrl();
    const extraFields = useExtraFields();

    return (
        <div className="logo-light hero-area" style={{ backgroundImage: `url("${apiUrl}/img/extern/ratio/www.bandwerk.nl/website/orig/2400/1813/100/${page.image}")` }}>
            <div className="hero-content">
                <h1 data-aos="fade-up" data-aos-duration="1000" dangerouslySetInnerHTML={{__html: extraFields?.home_header}}></h1>
            </div>

            <div className="shape">
                <img src="/assets/img/shape/shape-3.svg" alt="shape" />
            </div>

            <a href="#" className="scroll-down">
                <span>SCROLL</span>
                <img src="/assets/img/icons/arrow-down.svg" alt="icon" />
            </a>
        </div>
    );
}
